import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { APP_IMPORTS } from './app.imports';
import { APP_PROVIDERS } from './app.providers';
import { EnvironmentModule } from './environment/environment.module';
import { CurrencyPipe } from '@angular/common';
import { SharedModule } from './shared/shared.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    APP_IMPORTS,
    BrowserModule,
    EnvironmentModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: false
    }),
    SharedModule
  ],
  providers: [
    APP_PROVIDERS,
    CurrencyPipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
